import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { Layout } from "../../ui/layout"
import { Banner } from "../../ui/organisms/banner"
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../ui/organisms/navbar/dto"
import { DepartureDocuments } from "./departureDocuments"
import { EntryDocuments } from "./entryDocuments"
import { setSelectedTab } from "./slice"
import { UploadedDocuments } from "./uploadedDocuments"

export function GestioneDocumenti() {
    const dispatch = useAppDispatch()
    const documentManagementState = useAppSelector(state => state.documentManagement)
    const sessionState = useAppSelector(state => state.session)

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CLIENTI}
                breadcrumbItems={['Gestione Clienti', 'Documenti']}
                noPaddingLat
                headerLabel={"Gestione Documenti"}
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
            >
                <div className="min-w-0 max-w-full overflow-x-hidden">
                    <CustomHorizontalTab
                        selectedIndex={documentManagementState.selectedTab}
                        onTabClick={(index) => dispatch(setSelectedTab(index))}
                    >
                        <div>Documenti in Entrata</div>
                        <div>Documenti in Partenza</div>
                        <div>Documenti Caricati</div>
                    </CustomHorizontalTab>
                    <div className="flex h-full min-w-0 max-w-full overflow-x-hidden bg-brandPrimary-100">
                        <div className="fieldset flex-1 min-w-0 max-w-full overflow-x-hidden rounded-tr-2xl bg-brandPrimary-200">
                            {
                                documentManagementState.selectedTab === 0 &&
                                <EntryDocuments selectedCustomer={sessionState.selected.customerId} />
                            }
                            {
                                documentManagementState.selectedTab === 1 &&
                                <DepartureDocuments selectedCustomer={sessionState.selected.customerId} />
                            }
                            {
                                documentManagementState.selectedTab === 2 &&
                                <UploadedDocuments selectedCustomer={sessionState.selected.customerId} />
                            }
                        </div>
                    </div >
                </div>
            </Layout>
        )
    }
    else {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CLIENTI}
                breadcrumbItems={['Gestione Clienti', 'Documenti']}
                noPaddingLat
                headerLabel={"Gestione Documenti"}
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
            >
                <Banner
                    type="error"
                    visible={!sessionState.selected.customerId}
                    label={"Devi prima selezionare un cliente per accedere all'area"}
                    closeAction={function (): void {
                        alert("Devi prima selezionare un cliente per accedere all'area")
                    }}
                />
            </Layout>
        )
    }
}